import { connect } from 'react-redux';
import { getNecessaryProductsQuantity } from '../../../../store/form/selectors';
import ResultsSection from './ResultsSection';

const mapStateToProps = (state) => ({
  necessaryProductsQuantity: getNecessaryProductsQuantity(state),
});

export default connect(mapStateToProps)(ResultsSection);
